(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
  const desktop = window.matchMedia('(min-width: 750px)');
  const update = () => {
    document.querySelectorAll('.taia-footer-menu').forEach(menu => {
      menu.open = desktop.matches;
      const summary = menu.querySelector('summary');
      if (desktop.matches) summary.setAttribute('tabindex', '-1');
      else summary.removeAttribute('tabindex');
    });
  };
  desktop.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('click', event => {
    if (desktop.matches && event.target.closest('.taia-footer-menu summary')) event.preventDefault();
  });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taia-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('taia-moments')) {
  customElements.define('taia-moments', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.taia-moments__track');
      this.cards = [...this.querySelectorAll('[data-moment]')];
      this.steps = [...this.querySelectorAll('[data-go]')];
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (!this.cards.length) return;
      this.index = matchMedia('(max-width:749px)').matches ? 0 : Math.min(2, this.cards.length - 1);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }, { ...options, passive: true });
      this.addEventListener('click', event => {
        if (this.dragged) { event.preventDefault(); this.dragged = false; return; }
        const step = event.target.closest('[data-go]');
        const card = event.target.closest('[data-moment]');
        if (step) this.go(Number(step.dataset.go));
        else if (event.target.closest('[data-previous]')) this.go(this.index - 1);
        else if (event.target.closest('[data-next]')) this.go(this.index + 1);
        else if (card) this.go(Number(card.dataset.moment));
      }, options);
      this.addEventListener('keydown', event => {
        const offsets = { ArrowRight: 1, ArrowLeft: -1 };
        if (event.key in offsets) { event.preventDefault(); this.go(this.index + offsets[event.key]); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); this.go(event.key === 'Home' ? 0 : this.cards.length - 1); }
      }, options);
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.drag = { x: event.clientX, left: this.track.scrollLeft };
        this.dragged = false;
      }, options);
      window.addEventListener('pointermove', event => {
        if (!this.drag) return;
        const distance = event.clientX - this.drag.x;
        if (Math.abs(distance) > 5) {
          this.dragged = true;
          this.track.classList.add('is-dragging');
          this.track.scrollLeft = this.drag.left - distance;
        }
      }, options);
      const release = () => {
        if (!this.drag) return;
        this.drag = null;
        this.track.classList.remove('is-dragging');
        this.sync();
        this.go(this.index);
      };
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-moment]');
        if (card) this.go(Number(card.dataset.moment), false);
      }, options);
      this.resize = new ResizeObserver(() => this.go(this.index, false));
      this.resize.observe(this.track);
      this.go(this.index, false);
    }
    go(index, smooth = true) {
      this.index = Math.max(0, Math.min(this.cards.length - 1, index));
      const card = this.cards[this.index];
      const trackRect = this.track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const left = this.track.scrollLeft + cardRect.left - trackRect.left - (this.track.clientWidth - cardRect.width) / 2;
      this.track.scrollTo({ left, behavior: smooth && !matchMedia('(prefers-reduced-motion:reduce)').matches ? 'smooth' : 'instant' });
      this.paint();
    }
    sync() {
      const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
      let closest = Infinity;
      this.cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < closest) { closest = distance; this.index = index; }
      });
      this.paint();
    }
    paint() {
      this.cards.forEach((card, index) => {
        card.classList.toggle('is-active', index === this.index);
        card.style.setProperty('--turn', index < this.index ? '9deg' : '-9deg');
      });
      this.steps.forEach((step, index) => step.setAttribute('aria-pressed', String(index === this.index)));
      if (this.previous) this.previous.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.cards.length - 1;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taia-ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  class TaiaUgcGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ugc-track]');
      this.querySelector('[data-ugc-prev]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-ugc-next]')?.addEventListener('click', () => this.move(1));
      this.querySelectorAll('[data-ugc-sound]').forEach((button) => {
        button.addEventListener('click', () => {
          const video = button.closest('.taia-ugc__card')?.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          button.setAttribute('aria-pressed', String(!video.muted));
        });
      });
    }

    move(direction) {
      const card = this.track?.querySelector('.taia-ugc__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }
  }

  if (!customElements.get('taia-ugc-gallery')) {
    customElements.define('taia-ugc-gallery', TaiaUgcGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
